import { type StripeTosAgreementType } from '#app/__generated__/api.js';
import {
  type Alpha2CountryCodes,
  type StripeCurrency,
} from '#app/__generated__/relay/StripeContextProviderFragment.graphql.js';
import {
  type StripeCardStatus,
  type StripeContextProviderFragment_paymentMethods$data,
} from '#app/__generated__/relay/StripeContextProviderFragment_paymentMethods.graphql.js';
import { createContext } from 'react';

export type AllowedBillingAccountTypes =
  | CardBillingAccountType
  | SepaDebitAccountType
  | UsBankBillingAccountType;

export type BillingAccountType =
  NonNullable<StripeContextProviderFragment_paymentMethods$data>['paymentMethods']['edges'][number]['node'];

export type StripeContextType = {
  accountIsReady: boolean;
  achApproved: boolean;
  billingAccounts: AllowedBillingAccountTypes[];
  canDisconnect: boolean;
  canManagePaymentMethods: boolean;
  defaultBillingCard?: string;
  defaultCurrency: StripeCurrency;
  hasAccount: boolean;
  hasBillingAccounts: boolean;
  stripeCountry?: Alpha2CountryCodes;
  tosAgreementType: null | StripeTosAgreementType;
  userStripeFullName: string;
};

export type StripePaymentMethod = {
  accountType: 'StripeBankAccount' | 'StripeCard' | 'StripeSepaDebit';
  currency: StripeCurrency;
  id: string;
  isDefault: boolean;
  label: string;
  lastDigits?: number | string;
  status: StripeCardStatus;
};

type CardBillingAccountType = Extract<
  BillingAccountType,
  { __typename: 'StripeCard' }
>;

type SepaDebitAccountType = Extract<
  BillingAccountType,
  { __typename: 'StripeSepaDebitPaymentMethod' }
>;

type UsBankBillingAccountType = Extract<
  BillingAccountType,
  { __typename: 'StripeUsBankAccountPaymentMethod' }
>;

export const StripeContext = createContext<StripeContextType>({
  accountIsReady: false,
  achApproved: false,
  billingAccounts: [],
  canDisconnect: false,
  canManagePaymentMethods: false,
  defaultCurrency: 'USD',
  hasAccount: false,
  hasBillingAccounts: false,
  stripeCountry: undefined,
  tosAgreementType: null,
  userStripeFullName: '',
});
